import { CARGO_ROW_TYPE_LABEL, ICargoBreakdownListItem, TCargoRow } from '@types';
import { getCargoQuantitySegments } from './getCargoQuantitySegments';

/* One CargoBreakdownList line per cargo row - "Pallet · 3 Qty · 2 Spaces · 100 kg" - in the same format as the
   shipment's totals, with that row's own dimensions in place of its volume and its freight detail. Rows are never
   merged: two cargos of the same type would have been booked as one line if they shared dimensions, so each is
   assumed to differ. */
export const getCargoBreakdownListItems = (rows: TCargoRow[]): ICargoBreakdownListItem[] => {
	return rows.map((row) => ({
		summary: [CARGO_ROW_TYPE_LABEL[row.type] || row.typeLabel, ...getCargoQuantitySegments([{ ...row, cubic: 0 }])],
		length: row.length,
		width: row.width,
		height: row.height,
		descriptions: row.description ? [row.description] : []
	}));
};
